import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useI18n } from "@/contexts/I18nContext";

const RootRedirect = () => {
  const { user, loading } = useAuth();
  const { t } = useI18n();

  // 로딩 중이면 로딩 표시
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600 mx-auto mb-4"></div>
          <p className="text-gray-600">{t("common.loading")}</p>
        </div>
      </div>
    );
  }

  // 사용자 세션이 있으면 /main으로, 없으면 /login으로
  return user ? (
    <Navigate to="/main" replace />
  ) : (
    <Navigate to="/login" replace />
  );
};

export default RootRedirect;
